import React from 'react';
import { StyleSheet, View } from 'react-native';
import BodySmBoldText from 'shared/components/vxl/typography/primary/body/BodySmBoldText';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import theme from 'shared/styles/theme';

export interface DebtSaleFaqSectionProps {
  title: string;
  body: string;
}

const DebtSaleFaqSection = ({ title, body }: DebtSaleFaqSectionProps) => {
  return (
    <View style={styles.container} accessible={false}>
      <BodySmBoldText>{title}</BodySmBoldText>
      <BodySmText style={styles.body}>{body}</BodySmText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderColor: theme.color.border.primary,
    borderRadius: theme.spacing.xs,
    borderWidth: 1,
    gap: theme.spacing.s,
    padding: theme.spacing.m,
  },
  body: {
    color: theme.color.text.primary,
  },
});

export default DebtSaleFaqSection;
